import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=7a60d1d3&scoped=true&"
import script from "./DetailView.vue?vue&type=script&lang=js&"
export * from "./DetailView.vue?vue&type=script&lang=js&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=7a60d1d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60d1d3",
  null
  
)

export default component.exports